import React from "react";
import { FormControl, FormHelperText, TextField } from "@mui/material";

interface Props {
  value?: string;
  onChange: (value: string) => void;
  /** Set while the meeting is partner-private: such a meeting shares no room. */
  disabled?: boolean;
}

// Keys are used verbatim by the backend to derive the daily room id, so
// case/whitespace variants would silently split a day into separate rooms.
const sanitizeKey = (raw: string) =>
  raw.toLowerCase().replace(/[^a-z0-9_-]/g, "");

export const ContinuousRoomKeyField: React.FC<Props> = ({
  value,
  onChange,
  disabled = false,
}) => (
  <FormControl fullWidth margin="normal">
    <TextField
      label="Continuous Room Key"
      placeholder="e.g. community-session"
      value={value ?? ""}
      disabled={disabled}
      onChange={(e) => onChange(sanitizeKey(e.target.value))}
    />
    <FormHelperText>
      {disabled
        ? "Partner-only meetings never share a room or chat, so they have no key. Turning Partner-only off applies the room-key rules again."
        : "Meetings sharing this key on the same day appear to members as one continuous room (single link and chat for the whole day, with the host changing per slot). Leave empty to keep this a regular meeting."}
    </FormHelperText>
  </FormControl>
);
